import React, { useState } from 'react';
import './Toggle.style.css'; // Import the CSS styles for the toggle

type ToggleSwitchProps = {
  label: string;
  isCarChecked: boolean;
  handleCarToggle: () => void

};

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ label, isCarChecked, handleCarToggle }) => {
  
  return (
    <div className="toggle-switch">
      <p className='toggle-lable'>{label}</p>
      <label className="switch">
        <input type="checkbox" checked={isCarChecked} onChange={handleCarToggle} />
        <span className="slider" ><p className={`toggle-text ${isCarChecked ? "toggle-text-active" : "toggle-text-inactive"}`}></p></span>
      </label>
    </div>
  );
};

export default ToggleSwitch;
